import { IconButton } from '@patrianna/core-components'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { Eye, EyeOff } from '@patrianna-icons/material-icons'

import content from 'prismic-translates/loginpage.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  setTogglePass: (arg0: boolean) => void
  togglePass: boolean
  position?: 'start' | 'end'
}
export default function Adornment(props: Props) {
  const { togglePass, setTogglePass } = props

  return (
    <IconButton
      className={classes.icon}
      onClick={() => {
        setTogglePass(!togglePass)
      }}
      aria-label={t('toggle_pass_visibility_label')}
      edge='end'
      type='button'
    >
      {togglePass ? <Eye /> : <EyeOff />}
    </IconButton>
  )
}
